import Vue from "vue";
import VueRouter from "vue-router";

const login = () => import("@/views/login");
const home = () => import("@/views/home/index");
// 名片编辑
const cardMakeUp = () => import("@/views/cardDecoration/index.vue");
// 装修
const appletDesign = () => import("@/views/appletDesign/index.vue");
// 首页
const workSpace = () => import("@/views/workSpace/index.vue");
const newsList = () => import("@/views/workSpace/newsList.vue");
const newsDetail = () => import("@/views/workSpace/newsDetail.vue");

// 小程序
const applet = () => import("@/views/applet/index.vue");
const extension = () => import("@/views/applet/extension/index.vue");
const extensionGoods = () => import("@/views/applet/extension/extensionGoods.vue");
const extensionSmall = () => import("@/views/applet/extension/extensionSmall.vue");
const card = () => import("@/views/applet/card/index.vue");
const cardPrintAdd = () => import("@/views/applet/card/cardPrintAdd.vue");
const cardEdit = () => import("@/views/applet/card/cardEdit.vue");

const moments = () => import("@/views/applet/moments/index.vue");
const momentsEdit = () => import("@/views/applet/moments/momentsEdit.vue");

const appletsettings = () => import("@/views/applet/settings/index.vue");
const speechAdd = () => import("@/views/applet/settings/speechAdd.vue");

// 商城
const shopmall = () => import("@/views/shopmall/index.vue");
const goods = () => import("@/views/shopmall/goods/index.vue");
const addOrEditGoods = () =>
  import("@/views/shopmall/goods/addOrEditGoods.vue");

const freightmanage = () => import("@/views/shopmall/freightmanage/index.vue");
const createFreight = () =>
  import("@/views/shopmall/freightmanage/createFreight.vue");
const discount = () => import("@/views/shopmall/discount/index.vue");
const privilegeCouponEdit = () =>
    import("@/views/shopmall/discount/privilegeCouponEdit.vue");
const order = () => import("@/views/shopmall/order/index.vue");
const orderDetail = () => import("@/views/shopmall/order/orderDetail.vue");
const shopmallsettings = () => import("@/views/shopmall/settings/index.vue");
const decoration = () => import("@/views/shopmall/decoration/index.vue");


// 营销
const analytics = () => import("@/views/analytics/index.vue");
const material = () => import("@/views/analytics/material/index.vue");
const articleCreate = () =>
  import("@/views/analytics/material/articleCreate.vue");
const employeeDetails = () =>
  import("@/views/analytics/material/employeeDetails.vue");
const dataMember = () => import("@/views/analytics/material/dataMember.vue");
const dataCustomer = () =>
  import("@/views/analytics/material/dataCustomer.vue");

const official = () => import("@/views/analytics/official/index.vue");
const opportunity = () => import("@/views/analytics/opportunity/index.vue");
const activity = () => import("@/views/analytics/activity.vue");
const activityAdd = () => import("@/views/analytics/activityAdd.vue");
const distribution = () => import("@/views/analytics/distribution.vue");
const form = () => import("@/views/analytics/formlist.vue");
const formAdd = () => import("@/views/analytics/formAdd.vue");
const formEdit = () => import("@/views/analytics/formEdit.vue");
const formtable = () => import("@/views/analytics/formtable.vue");
const marketVideo = () => import("@/views/analytics/marketVideo.vue");
const addOrEditVideo = () => import("@/views/analytics/addOrEditVideo.vue");

const groupBuying = () => import("@/views/analytics/groupBuying.vue");
const groupBuyingAddOrEdit = () =>
  import("@/views/analytics/groupBuyingAddOrEdit.vue");

const notification = () => import("@/views/analytics/notification.vue");
const notificationAdd = () => import("@/views/analytics/notificationAdd.vue");
const album = () => import("@/views/analytics/album/index.vue");
const addOrEditAlbum = () => import("@/views/analytics/album/addOrEditAlbum.vue");

// 宣传册
const brochure = () => import("@/views/analytics/brochure/index.vue");
const addOrEditBrochure = () => import("@/views/analytics/brochure/addOrEditBrochure.vue");

// 拓客-概况
const tuoke = () => import("@/views/tuoke/index.vue");
const tkWorkSpace = () => import("@/views/tuoke/tkWorkSpace/index.vue");//拓客数据
const tkShenhe = () => import("@/views/tuoke/tkShenhe/index.vue");//审核员工管理
const shenhe = () => import("@/views/tuoke/tkShenhe/shenhe.vue");//添加异业联盟商家
const tkMerchant = () => import("@/views/tuoke/tkMerchant/index.vue");//联盟商家管理
const addOrEditMerchant = () => import("@/views/tuoke/tkMerchant/addOrEditMerchant.vue");//添加异业联盟商家
const tkAnalytics = () => import("@/views/tuoke/tkAnalytics/index.vue");//拓客活动管理
const addOrEditTuoke = () => import("@/views/tuoke/tkAnalytics/addOrEditTuoke.vue");//创建活动
const templateList = () => import("@/views/tuoke/tkAnalytics/templateList.vue");//选择模板列表
const tkJournal = () => import("@/views/tuoke/tkJournal/index.vue");//拓客日志-购买日志
const tkFundManage = () => import("@/views/tuoke/tkFundManage/index.vue");//拓客资金管理

const sharelogin = () => import("@/views/tuoke/tkJournal/sharelogin.vue");
const participationlog = () => import("@/views/tuoke/tkJournal/participationlog.vue");
const purchaselog = () => import("@/views/tuoke/tkJournal/purchaselog.vue");
const drawLog = () => import("@/views/tuoke/tkJournal/drawLog.vue");
const dyLog = () => import("@/views/tuoke/tkJournal/dyLog.vue");


// 客户
const customer = () => import("@/views/customer/index.vue");
const customerLebel = () => import("@/views/customer/lebel.vue");

// 员工
const employee = () => import("@/views/employee/index.vue");
const employeeAdd = () => import("@/views/employee/employeeAdd.vue");
const employeeEdit = () => import("@/views/employee/employeeEdit.vue");
const employeeDetail = () => import("@/views/employee/employeeDetail.vue");

const handover = () => import("@/views/employee/handover.vue");
const lockguest = () => import("@/views/employee/lockguest.vue");
const manage = () => import("@/views/employee/manage.vue");
const roles = () => import("@/views/employee/roles.vue");
const enployeemanage = () => import("@/views/employee/enployeemanage.vue");
const enployeemanageEdit = () =>
  import("@/views/employee/enployeemanageEdit.vue");

// 财务
const finance = () => import("@/views/finance/index.vue");
const commissions = () => import("@/views/finance/commissions/index.vue");
const refundOrder = () => import("@/views/finance/refundOrder.vue");
const refundOrderDetail = () => import("@/views/finance/refundOrderDetail.vue");

// 设置
const settings = () => import("@/views/settings/index.vue");
const authorization = () => import("@/views/settings/authorization/index.vue");
const startUp = () => import("@/views/settings/authorization/startUp.vue");
const startUpRule = () =>
  import("@/views/settings/authorization/startUpRule.vue");
const miniappPannelCate = () =>
  import("@/views/settings/authorization/miniappPannelCate.vue");
const miniappPannelEdit = () =>
  import("@/views/settings/authorization/miniappPannelEdit.vue");
const enterprise = () => import("@/views/settings/enterprise.vue");
const openplatform = () => import("@/views/settings/openplatform.vue");
const payment = () => import("@/views/settings/payment.vue");

// 意见反馈
const feedback = () => import("@/views/feedback/index");
const feedbackList = () => import("@/views/feedback/feedbackList");
const addFeedback = () => import("@/views/feedback/addFeedback");
const editFeedback = () => import("@/views/feedback/editFeedback");

// 积分商城
const integral = () => import("@/views/shopmall/integral/index.vue");
const addOrEditIntegral = () => import("@/views/shopmall/integral/addOrEditIntegral.vue");

//合伙人分红
const partner = () => import("@/views/partner/index.vue");
const rugu = () => import("@/views/partner/rugu/index.vue");
const add = () => import("@/views/partner/add/index.vue");
const addPartner = () => import("@/views/partner/add/addPartner.vue");
const partnerEdit = () => import("@/views/partner/add/partnerEdit.vue");
const extpartnerEdit = () => import("@/views/partner/add/extpartnerEdit.vue");
const addextPartner = () => import("@/views/partner/add/addextPartner.vue");

const buy = () => import("@/views/partner/buy/index.vue");
const customerRecord = () => import("@/views/partner/customerRecord/index.vue");
const scheme = () => import("@/views/partner/scheme/index.vue");
const pfplan = () => import("@/views/partner/scheme/pfplan.vue");
const planEdit = () => import("@/views/partner/scheme/planEdit.vue");
const addcustomer = () => import("@/views/partner/buy/addcustomer.vue");
const summary = () => import("@/views/partner/summary/index.vue");





Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/cardMakeUp",
    name: "cardMakeUp",
    component: cardMakeUp
  },
  {
    path: "/home",
    component: home,
    name: "home",
    redirect: "/home/workSpace",
    children: [
      {
        path: "workSpace",
        component: workSpace,
        name: "workSpace"
      },
      {
        path: "newsList",
        component: newsList,
        name: "newsList"
      },  
      {
        path: "newsDetail",
        component: newsDetail,
        name: "newsDetail"
      },          
      {
        path: "applet",
        component: applet,
        name: "applet",
        children: [
          {
            path: "card",
            component: card,
            name: "card"
          },
          {
            path: "cardPrintAdd",
            component: cardPrintAdd,
            name: "cardPrintAdd"
          },
          {
            path: "cardEdit",
            component: cardEdit,
            name: "cardEdit"
          },
          {
            path: "moments",
            component: moments,
            name: "moments"
          },
          {
            path: "momentsEdit",
            component: momentsEdit,
            name: "momentsEdit"
          },
          {
            path: "appletsettings",
            component: appletsettings,
            name: "appletsettings"
          },
          {
            path: "speechAdd",
            component: speechAdd,
            name: "speechAdd"
          },
          {
            path: "appletDesign",
            name: "appletDesign",
            component: appletDesign
          },
          {
            path: "extension",
            name: "extension",
            component: extension
          },
          {
            path: "extensionGoods",
            name: "extensionGoods",
            component: extensionGoods
          },
          {
            path: "extensionSmall",
            name: "extensionSmall",
            component: extensionSmall
          }
        ]
      },
      {
        path: "shopmall",
        component: shopmall,
        name: "shopmall",
        children: [
          {
            path: "goods",
            component: goods,
            name: "goods"
          },
          {
            path: "addOrEditGoods",
            component: addOrEditGoods,
            name: "addOrEditGoods"
          },
          {
            path: "freightmanage",
            component: freightmanage,
            name: "freightmanage"
          },
          {
            path: "createFreight",
            component: createFreight,
            name: "createFreight"
          },
          {
            path: "order",
            component: order,
            name: "order"
          },
          {
            path: "orderDetail",
            component: orderDetail,
            name: "orderDetail"
          },
          {
            path: "shopmallsettings",
            component: shopmallsettings,
            name: "shopmallsettings"
          },
          {
            path: "discount",
            component: discount,
            name: "discount"
          },
          {
            path: "privilegeCouponEdit",
            component: privilegeCouponEdit,
            name: "privilegeCouponEdit"
          },		  
          {
            path: "decoration",
            component: decoration,
            name: "decoration"
          },
          {
            path: "integral",
            component: integral,
            name: "integral"
          },
          {
            path: "addOrEditIntegral",
            component: addOrEditIntegral,
            name: "addOrEditIntegral"
          }
        ]
      },
      {
        path: "analytics",
        component: analytics,
        name: "analytics",
        children: [
          {
            path: "groupBuying",
            component: groupBuying,
            name: "groupBuying"
          },
          {
            path: "groupBuyingAddOrEdit",
            component: groupBuyingAddOrEdit,
            name: "groupBuyingAddOrEdit"
          },
          {
            path: "distribution",
            component: distribution,
            name: "distribution"
          },
          {
            path: "marketVideo",
            component: marketVideo,
            name: "marketVideo"
          },          
          {
            path: "addOrEditVideo",
            component: addOrEditVideo,
            name: "addOrEditVideo"
          },          
          {
            path: "form",
            component: form,
            name: "form"
          },
          {
            path: "formAdd",
            component: formAdd,
            name: "formAdd"
          },
          {
            path: "formtable",
            component: formtable,
            name: "formtable"
          },
          {
            path: "formEdit",
            component: formEdit,
            name: "formEdit"
          },
          {
            path: "activity",
            component: activity,
            name: "activity"
          },
          {
            path: "activityAdd",
            component: activityAdd,
            name: "activityAdd"
          },
          {
            path: "material",
            component: material,
            name: "material"
          },
          {
            path: "dataMember",
            component: dataMember,
            name: "dataMember"
          },
          {
            path: "dataCustomer",
            component: dataCustomer,
            name: "dataCustomer"
          },

          {
            path: "employeeDetails",
            component: employeeDetails,
            name: "employeeDetails"
          },

          {
            path: "articleCreate",
            component: articleCreate,
            name: "articleCreate"
          },

          {
            path: "notification",
            component: notification,
            name: "notification"
          },
          {
            path: "notificationAdd",
            component: notificationAdd,
            name: "notificationAdd"
          },
          {
            path: "official",
            component: official,
            name: "official"
          },
          {
            path: "opportunity",
            component: opportunity,
            name: "opportunity"
          },
          {
            path: "brochure",
            component: brochure,
            name: "brochure"
          },
          {
            path: "addOrEditBrochure",
            component: addOrEditBrochure,
            name: "addOrEditBrochure"
          },         
          {
            path: "album",
            component: album,
            name: "album"         
          },
          {
            path: "addOrEditAlbum",
            component: addOrEditAlbum,
            name: "addOrEditAlbum"
          }          
        ]
      },
      {
        path: "tuoke",
        component: tuoke,
        name: "tuoke",
        children: [
          {
            path: "tkWorkSpace",
            component: tkWorkSpace,
            name: "tkWorkSpace"
          },
          {
            path: "tkAnalytics",
            component: tkAnalytics,
            name: "tkAnalytics"
          },
          {
            path: "tkJournal",
            component: tkJournal,
            name: "tkJournal",
            children: [
              {
                path: "sharelogin",
                component: sharelogin,
                name: "sharelogin"		
              },
              {
                path: "participationlog",
                component: participationlog,
                name: "participationlog"
              },
              {
                path: "purchaselog",
                component: purchaselog,
                name: "purchaselog"
              },
              {
                path: "drawLog",
                component: drawLog,
                name: "drawLog"
              },
              {
                path: "dyLog",
                component: dyLog,
                name: "dyLog"
              }
            ]
          },
          {
            path: "tkFundManage",
            component: tkFundManage,
            name: "tkFundManage"
          },
          {
            path: "tkShenhe",
            component: tkShenhe,
            name: "tkShenhe"
          },
          {
            path: "shenhe",
            component: shenhe,
            name: "shenhe"
          },
          {
            path: "tkMerchant",
            component: tkMerchant,
            name: "tkMerchant"
          },
          {
            path: "addOrEditMerchant",
            component: addOrEditMerchant,
            name: "addOrEditMerchant"
          },
          {
            path: "addOrEditTuoke",
            component: addOrEditTuoke,
            name: "addOrEditTuoke"
          },
          {
            path: "templateList",
            component: templateList,
            name: "templateList"
          }
        ]
      },
      {
        path: "customer",
        component: customer,
        name: "customer",
        children: []
      },
      {
        path: "customerLebel",
        component: customerLebel,
        name: "customerLebel",
        children: []
      },
      {
        path: "employee",
        component: employee,
        name: "employee",
        children: [
          {
            path: "lockguest",
            component: lockguest,
            name: "lockguest"
          },
          {
            path: "employeeAdd",
            component: employeeAdd,
            name: "employeeAdd"
          },
          {
            path: "employeeEdit",
            component: employeeEdit,
            name: "employeeEdit"
          },
          {
            path: "employeeDetail",
            component: employeeDetail,
            name: "employeeDetail"
          },
          {
            path: "handover",
            component: handover,
            name: "handover"
          },
          {
            path: "manage",
            component: manage,
            name: "manage"
          },
          {
            path: "roles",
            component: roles,
            name: "roles"
          },
          {
            path: "enployeemanage",
            component: enployeemanage,
            name: "enployeemanage"
          },
          {
            path: "enployeemanageEdit",
            component: enployeemanageEdit,
            name: "enployeemanageEdit"
          }
        ]
      },
      {
        path: "finance",
        component: finance,
        name: "finance",
        children: [
          {
            path: "commissions",
            component: commissions,
            name: "commissions"
          },
          {
            path: "refundOrder",
            component: refundOrder,
            name: "refundOrder"
          },
          {
            path: "refundOrderDetail",
            component: refundOrderDetail,
            name: "refundOrderDetail"
          }
        ]
      },
      {
        path: "settings",
        component: settings,
        name: "settings",
        children: [
          {
            path: "authorization",
            component: authorization,
            name: "authorization"
          },
          {
            path: "startUp",
            component: startUp,
            name: "startUp"
          },
          {
            path: "startUpRule",
            component: startUpRule,
            name: "startUpRule"
          },
          {
            path: "miniappPannelEdit",
            component: miniappPannelEdit,
            name: "miniappPannelEdit"
          },
          {
            path: "miniappPannelCate",
            component: miniappPannelCate,
            name: "miniappPannelCate"
          },
          {
            path: "enterprise",
            component: enterprise,
            name: "enterprise"
          },
          {
            path: "payment",
            component: payment,
            name: "payment"
          },
          {
            path: "openplatform",
            component: openplatform,
            name: "openplatform"
          }
        ]
      },
      {
        path: "partner",
        component: partner,
        name: "partner",
        children: [
          {
            path: "rugu",
            component: rugu,
            name: "rugu"
          },  
          {
            path: "add",
            component: add,
            name: "add"
          }, 
          {
            path: "addPartner",
            component: addPartner,
            name: "addPartner"
          },
          {
            path: "partnerEdit",
            component: partnerEdit,
            name: "partnerEdit"
          }, 
          {
            path: "extpartnerEdit",
            component: extpartnerEdit,
            name: "extpartnerEdit"
          },
          {
            path: "addextPartner",
            component: addextPartner,
            name: "addextPartner"
          },
          {
            path: "buy",
            component: buy,
            name: "buy"
          },     
            {
            path: "customerRecord",
            component: customerRecord,
            name: "customerRecord"
          },
          {
            path: "scheme",
            component: scheme,
            name: "scheme"
          },
          {
            path: "pfplan",
            component: pfplan,
            name: "pfplan"
          },
          {
            path: "planEdit",
            component: planEdit,
            name: "planEdit"
          },
          {
            path: "addcustomer",
            component: addcustomer,
            name: "addcustomer"
          },

          {
            path: "summary",
            component: summary,
            name: "summary"
          },
        ]
      },
      {
        path: "feedback",
        component: feedback,
        name: "feedback",
        children: [
          {
            path: "feedbackList",
            component: feedbackList,
            name: "feedbackList"
          },          
          {
            path: "addFeedback",
            component: addFeedback,
            name: "addFeedback"
          },
          {
            path: "editFeedback",
            component: editFeedback,
            name: "editFeedback"
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  if (to.query.token && to.query.keyid) {
    sessionStorage.setItem("token", to.query.token);
    sessionStorage.setItem("keyid", to.query.keyid);
    window.href = "/dist/#/";
    next();
  } else {
    if (sessionStorage.getItem("token")) {
      // 已经存在进行登入
      if (to.path === "/login") {
        // window.location.href = 'https://b.yunzhidata.cn/dist/#/home/workSpace'
        // }
        // if (to.path === '/home/workSpace' && from.path === '/login') {
        //   // window.location.href = 'https://b.yunzhidata.cn/dist/#/home/workSpace'
        //   this.$router.replace('/home/workSpace')
        // }
        // router.replace('/home/workSpace')
        // window.location.href = 'https://b.yunzhidata.cn/dist/#/home/workSpace'
        // window.location.href = '/dist/#/home/workSpace'
        next({ path: "/home/workSpace" });
      } else {
        // window.location.href = 'https://b.yunzhidata.cn/dist/#/login'
        next();
      }
      // next()
    } else {
      next();
    }
    // if (!sessionStorage.getItem("token") && to.path !== '/') {
    //   // next({
    //   //   path: '/',
    //   //   query: {redirect: route.fullPath}
    //   // })
    //   next({
    //     path: '/login'
    //   })
    // } else {
    //   console.log("-------------------",route,redirect);
    //   next()
    // }
  }
});

export default router;
